import { render } from "./frequency-toggle-small.vue?vue&type=template&id=276db916&lang=pug"
import script from "./frequency-toggle-small.vue?vue&type=script&lang=js"
export * from "./frequency-toggle-small.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__